import "./Register.scss";
import logo from "../../../images/logo.png";
import React from "react";
import { t } from "i18next";
import { performRegister } from "../../../utils/auth";
import { NavLink } from "react-router-dom";
import { generateCaptcha } from "../../../utils/captcha";

class Register extends React.Component<{}, {}> {
  private captcha = generateCaptcha();

  async onSubmitHandler(e: any) {
    e.preventDefault();
    const form = Object.fromEntries(new FormData(e.target).entries()) as any;
    if (
      await performRegister(
        form.username,
        form.email,
        form.password,
        form["captcha-question"],
        form["captcha-answer"]
      )
    ) {
      (window as any).location = "/";
    }
  }

  render() {
    return (
      <div>
        <section className="bg-gray-900">
          <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
            <span className="flex items-center mb-6 text-2xl font-semibold text-white">
              <img className="h-16 mr-2" src={logo} alt="logo" />
            </span>
            <div className="w-full rounded-lg shadow border md:mt-0 sm:max-w-md xl:p-0 bg-gray-800 border-gray-700">
              <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                <h1 className="text-xl font-bold leading-tight tracking-tight md:text-2xl text-white">
                  {t("register.title")}
                </h1>
                <form
                  className="space-y-4 md:space-y-6"
                  onSubmit={this.onSubmitHandler}
                >

                  <div>
                    <label className="block mb-2 text-sm font-medium text-white">
                      {t("register.fields.username.label")}
                    </label>
                    <input
                      type="username"
                      name="username"
                      id="username"
                      placeholder={t("register.fields.username.placeholder")}
                      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-white">
                      {t("register.fields.email.label")}
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder={t("register.fields.email.placeholder")}
                      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-white">
                      {t("register.fields.password.label")}
                    </label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      placeholder={t("register.fields.password.placeholder")}
                      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-white">
                      {t("register.fields.captcha.label")} : {this.captcha}
                    </label>
                    <input
                      type="hidden"
                      name="captcha-question"
                      id="captcha-question"
                      value={this.captcha}
                    />
                    <input
                      type="text"
                      name="captcha-answer"
                      id="captcha-answer"
                      placeholder={t("register.fields.captcha.placeholder")}
                      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full text-white bg-blue-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-primary-600 hover:bg-primary-700 focus:ring-primary-800"
                  >
                    {t("register.button")}
                  </button>
                  <p className="text-sm font-light text-gray-400">
                    {t("register.already-has-account")}
                    &nbsp;
                    <NavLink
                      to="/login"
                      className="font-medium hover:underline text-primary-500"
                    >
                      {t("register.login")}
                    </NavLink>
                  </p>
                </form>
              </div>
            </div>
            <div className="text-gray-600 py-6 text-sm">
              {t("technical.commit_hash")}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Register;
